<!--Site Footer Two Start-->
<footer class="site-footer-two">
    <div class="site-footer-two__shape-1 float-bob-x">
        <img src="assets/images/shapes/site-footer-two-shape-1.png" alt="">
    </div>
    <div class="container">
        <div class="site-footer-two__top">
            <div class="row">



                <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                    <div class="footer-widget-two__column footer-widget-two__newsletter">
                        <h3 class="footer-widget-two__newsletter-title">
Shingad shipping lines private limited
                        </h3> <br>
                        <form action="https://dreamlayout.mnsithub.com/html/tanspot/main-html/assets/inc/sendemail.php"
                            method="POST" class="footer-widget-two__newsletter-form contact-form-validated">
                            <div class="footer-widget-two__newsletter-form-input-box">
                                <p style="text-align: justify; color:#fff;">We are committed to exporting premium quality Kerala hill, forest, and agricultural products to global markets with strict quality control,
                                     hygienic packaging, and international standards. Ship Chandling Division <a routerLink="/about">Learn More</a> </p>
                            </div>
                            <div class="result"></div>
                        </form>
                        <!-- <div class="site-footer-two__social">
                            <a href="https://www.facebook.com/thanvika.enterprises25/"><i class="icon-facebook-app-symbol"></i></a>
                            <a href="https://x.com/thanvikaentps25"><i class="icon-twitter1"></i></a>
                            <a href="https://www.instagram.com/thanvika_enterprises_/"><i class="icon-instagram"></i></a>
                      
                        </div> -->
                    </div>
                </div>

                <div class="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                    <div class="footer-widget-two__column footer-widget-two__usefull-link">
                        <div class="footer-widget-two__title-box">
                            <h3 class="footer-widget-two__title">Quick Links</h3>
                        </div>
                        <div class="footer-widget-two__link-box">
                            <ul class="footer-widget-two__link list-unstyled">
                                <li><a routerLink="">Home</a></li>
                                <li><a routerLink="/about">About Us</a></li>
                                <li><a routerLink="/gallery">Gallery</a></li>

                                <li><a routerLink="/contact">Contact</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                    <div class="footer-widget-two__column footer-widget-two__services">
                        <div class="footer-widget-two__title-box">
                            <h3 class="footer-widget-two__title">Our Services</h3>
                        </div>
                        <ul class="footer-widget-two__link list-unstyled">
                            <li><a routerLink="/spices-products">Shipping Logistics & Export / Imports</a>
                            </li>
                            <li><a routerLink="/ship-chandling-division"> Shipping & Maritime Operations</a>
                            </li>
                            <li><a routerLink="/port-operations">Port and Hydrography </a></li>
                          <li><a routerLink="/legal-services">Legal Services </a></li>


                        </ul>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                    <div class="footer-widget-two__title-box">
                        <h3 class="footer-widget-two__title">Contact Us</h3>
                    </div>
                    <div class="footer-widget-two__column footer-widget-two__about">
                        <!-- <div class="footer-widget-two__logo">
                                    <a href="index.html"><img src="assets/images/resources/logo-2.png" alt=""></a>
                                </div> -->


                      
                        <ul class="footer-widget-two__contact list-unstyled">
                            <li>
                                <div class="icon">
                                    <span class="icon-phone-call"></span>
                                </div>
                                <div class="content">
                                    <h5>Contact</h5>
                                    <p><a href="tel:+9447117399">+91 944 7117 399</a></p>
                               

                                </div>
                            </li>

                        

                            <li>
                                <div class="icon">
                                    <span class="icon-location1"></span>
                                </div>
                                <div class="content">
                                    <h5>Location 1</h5>
                                    <p>Court view inn, vanchiyoor p.o.,
                                        <br>
                                       Thiruvananthapuram -35,   <br>
Kerala state, India
                                    </p>
                                </div>
                            </li>


                             <li>
                                <div class="icon">
                                    <span class="icon-location1"></span>
                                </div>
                                <div class="content">
                                    <h5>Location 2</h5>
                                    <p>TC 8/1057, Kamukumpallil, Kallampally,    <br>
Thiruvananthapuram Medical College,    <br>
Thiruvananthapuram, Kerala, 695011
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="site-footer-two__bottom">
        <div class="container">
            <div class="site-footer-two__bottom-inner">
                <p class="site-footer-two__bottom-text">© 2026 by <a href="#">Shingad Shipping LInes Pvt Ltd </a> All Rights Reserved.</p>
                <ul class="list-unstyled site-footer-two__bottom-menu">
                    <li><a href="contact.html">Support</a></li>
                    <li><a href="about.html">Terms and Condition</a></li>
                
                </ul>
            </div>
        </div>
    </div>
</footer>
<!--Site Footer Two End-->